// extracted by mini-css-extract-plugin
export default {"info":"eWpwNyk9oPj190yX87GA","title":"YF2IMcGID70pLRlmMIKP","text":"R9rbF6TdzvhsGLf4WRWX"};